import { motion } from "framer-motion";
import { useEffect } from "react";
import { Helmet } from "react-helmet";

export default function DigitalStrategyPage() {
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, []);
  return (
    <main className="bg-white text-gray-800">
      <Helmet>
        <title>Digital Strategy | Codexa</title>
        <meta
          name="description"
          content="Codexa's digital strategy services help businesses align their technology, marketing, and data to drive measurable results."
        />
      </Helmet>

      {/* Hero Section */}
      <section className="bg-indigo-600 text-white py-20 text-center">
        <motion.div
          initial={{ opacity: 0, y: -40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="max-w-3xl mx-auto px-4 space-y-6"
        >
          <h1 className="text-4xl md:text-5xl font-bold">
            Digital Strategy Services
          </h1>
          <p className="text-lg md:text-xl">
            Empowering your business with actionable insights, optimized
            marketing, and tech-driven strategies.
          </p>
        </motion.div>
      </section>

      {/* Features Section */}
      <section className="py-16 px-6 max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl font-bold text-indigo-600">
            What We Offer
          </h2>
          <p className="text-gray-600 mt-2 max-w-2xl mx-auto">
            We align your business goals with cutting-edge digital solutions,
            ensuring scalability and long-term success.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-10">
          {[
            {
              title: "Market Research & Trends",
              desc: "Gain competitive insights and forecast shifts to plan smarter.",
              icon: "📊",
            },
            {
              title: "Digital Transformation",
              desc: "Streamline operations through data-driven digitalization.",
              icon: "🔄",
            },
            {
              title: "Omni-Channel Strategy",
              desc: "Reach your audience across every platform with consistency.",
              icon: "🌐",
            },
            {
              title: "Content Strategy",
              desc: "Develop impactful content that drives engagement and SEO.",
              icon: "📝",
            },
            {
              title: "Analytics & KPIs",
              desc: "Set measurable goals and track success using key metrics.",
              icon: "📈",
            },
            {
              title: "Tech Advisory",
              desc: "Make informed choices on software, platforms, and automation.",
              icon: "🧠",
            },
          ].map((item, i) => (
            <motion.div
              key={i}
              whileHover={{ scale: 1.05 }}
              className="bg-white shadow-md rounded-2xl p-6 text-center border hover:shadow-xl transition"
            >
              <div className="text-4xl mb-4">{item.icon}</div>
              <h3 className="text-xl font-semibold text-indigo-600">
                {item.title}
              </h3>
              <p className="text-gray-600 mt-2">{item.desc}</p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* Call to Action */}
      <section className="bg-indigo-50 py-16">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          className="max-w-4xl mx-auto text-center px-4 space-y-6"
        >
          <h2 className="text-3xl font-bold text-indigo-600">
            Ready to level up your digital growth?
          </h2>
          <p className="text-gray-700 text-lg">
            Let Codexa be your strategic partner in innovation and growth.
          </p>
          <a
            href="/contact"
            className="inline-block px-8 py-3 bg-indigo-600 text-white rounded-full text-lg font-medium hover:bg-indigo-700 transition"
          >
            Start a Conversation
          </a>
        </motion.div>
      </section>
    </main>
  );
}
